import "./App.css";
import BottomLine from "./Components/BottomLine";
import TopLine from "./Components/TopLine";

function App() {
  return (
    <div className="container">
      <TopLine />
      <BottomLine />
    </div>
  );
}

export default App;
